import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./.././../../assets/css/add-new-question.css";
import { Redirect } from 'react-router';
import Header from "./../../Header";
import Menu from "./../../Menu";
import {SURGEON} from './../../../services/Surgeon';
import { CONFIG, URLS } from "./../../../helpers/Common";

class PatientResponse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patient_additional_info: "",
      prevStep: 5,
      profileData: new Array(),
      redirect: false,
      redirectLisint:false,
      //patientAdditionalInfo:''
    };
    this.handleAction = this.handleAction.bind(this);
    this.setAddionalInfo = this.setAddionalInfo.bind(this);
  }

  componentWillMount() {
    this.setState({
      profileData: this.props.getProfileData,
      patient_additional_info:this.props.getPatientAdditionalInfo
    });
    
  }
  handleAction = e => {
    let profileData = this.state.profileData;
    profileData.patient_additional_info = this.state.patient_additional_info;

    localStorage.setItem('patientProfile',  JSON.stringify(profileData));
    let data = JSON.parse(localStorage.getItem('data'));
    let complainData = this.props.getComplainData.complainTypeDetails;
    let all_complains = JSON.parse(localStorage.getItem("allComplains"));
    let newData = JSON.parse(localStorage.getItem("newData"));

    let saveData = new Array();
    let complainLocationData = this.props.getComplainLocationData;
    saveData = {
      patient_additional_info: this.state.patient_additional_info,
      answers:data,
      narrative_summary: profileData.narrative_summary,
      patient_id:this.props.getPatientId,
      all_complaints:all_complains,
      newData:newData,
      title: profileData.title,
      first_name: profileData.first_name,
      last_name: profileData.last_name,
      email: profileData.email,
      phone: profileData.phone,
      gender: profileData.gender,
      surgeon_id: this.props.surgeon_id,
      dob: profileData.dob,
    };
    if(this.props.isModify==true)
    {
      saveData['narrative_id'] = this.props.getNarrativeId;
      SURGEON.updatePatientNarrative(JSON.stringify(saveData)).then(res => {
        if(res.data.header.error==0)
        {
          localStorage.removeItem('data');
          localStorage.removeItem('patientProfile');
          this.setState({redirectLisint: true});
        }
        else
        {
          alert('There was an error in update narrative')
          this.setState({redirectLisint: true});
        }

      }).catch(err => {
          console.log(err);
          alert("There was an error in server response");
          this.setState({redirectLisint: true});
      });
    }
    else
    {
      console.log(saveData);
      localStorage.setItem("data",JSON.stringify(saveData));
      localStorage.setItem("allComplains",JSON.stringify(this.props.getAllComplains));
        this.setState({
        redirect:true
      })
    }

  };

  setAddionalInfo = e => {
    this.setState({
      patient_additional_info: e.target.value
    });
  };

  
  render() {
    if (this.state.redirect) {
      let path = "/surgeon/complain/thankyou/"+this.props.getPatientId;
      return <Redirect push to={path} />;
    }
    if (this.state.redirectLisint) {
      let path = "/surgeon/patients";
      return <Redirect push to={path} />;
    }
    return (
      <React.Fragment>
        <Header
          title="Patient Narrative Response"
          titleImage="ic-medical-result.png"
        />
        <Menu />
        <section className="sec--question add-new-question">
          <form>
            <div className="question-form">
              <div className="container">
                <div className="row">
                  <div className="col-md-1 col-sm-1" />
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="form-group">
                      <label htmlFor="txt">Add Any Additional Info</label>
                      <textarea
                        id="txt"
                        className="form-control"
                        onChange={this.setAddionalInfo}
                        value={this.state.patient_additional_info}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
        <div className="sec-btn patient--btn">
          <Link to="#" className="btn-img" onClick={this.handleAction}>
            <img
              src={require("./.././../../assets/img/icons/ic-incomplete-native.png")}
              alt=""
            />
            <span>Skip</span>
          </Link>
          <Link to="#" className="btn-img" onClick={this.handleAction}>
            <img
              src={require("./.././../../assets/img/icons/ic-complete-native.png")}
              alt=""
            />
            <span>Save</span>
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default PatientResponse;
